import notificationAnalyticsTypes from "./notificationAnalyticsTypes";
import notificationAnalyticsApi from "./notificationAnalyticsApi";

const notificationAnalyticsActions = {
    getAutoNotificationAnalytics: (branch_id, resolve, reject) => async dispatch => {
        dispatch({ type: notificationAnalyticsTypes.GET_AUTO_NOTIFICATION_ANALYTICS_PENDING })
        await notificationAnalyticsApi.getAutoNotificationAnalytics(branch_id)
            .then((data) => {
                dispatch({ type: notificationAnalyticsTypes.GET_AUTO_NOTIFICATION_ANALYTICS_SUCCESS, payload: data })
                resolve && resolve()
            })
            .catch((e) => {
                dispatch({ type: notificationAnalyticsTypes.GET_AUTO_NOTIFICATION_ANALYTICS_ERROR })
                reject && reject(e)
            })
    },
}

export default notificationAnalyticsActions;
